//libraries
import React, { FunctionComponent, useEffect, useState, useRef } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import SessionService from '../../services/SessionsService';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
// import './NewLandingFramework.css'

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';

//assets

import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'
import ReactGA from 'react-ga4';
import config from '../../configs/appConfig.json'


import icon_mail from '../../assets/img/ui_icons/icono-mail-red.svg'
import icon_phone from '../../assets/img/ui_icons/icono-phone.svg'
import icon_country from '../../assets/img/ui_icons/icono-country.svg'
import icon_doc from '../../assets/img/ui_icons/icono-country.svg'
import icon_puzzle from '../../assets/img/ui_icons/icono-country.svg'



import profilePicture from '../../assets/img/placeholder/profile.jpeg'



import { BrowserView, MobileView } from 'react-device-detect';


type DashProps = {
    sider: any
};



const devInfo = () => {

    useEffect(() => {
        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // favicon

        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
        //ReactGA.initialize('G-MQZQJN7TQL');
        if (config.url != 'https://avs-primary-pre.101obex.mooo.com') {
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Marketplace | API Products' });
        }

    }, []);





    return (
        <>
            <NavbarMarket />
            <div id='mktmyApis' className="w-100 bg-antiflash vh-100">
                <div className="container pt-5">
                    <div className="row">
                        <div className="col">
                            <p className="subtitulo">Developer Information</p>
                            <hr />
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="pInfoWrapper">
                                <div id='#profilePicture' className='profilePicture' style={{ backgroundImage: `url(${profilePicture})` }}></div>
                                <div className="info">
                                    <p className='labelIcon'>Developer Name</p>
                                    <p className='data'>Nombre Apellido <br />Doble Línea</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="labelIcon"><Image src={icon_mail} />Mail</div>
                            <div className="data">ejemplo@correo.com</div>
                        </div>
                        <div className="col-md-4">
                            <div className="labelIcon"><Image src={icon_phone}/> Phone</div>
                            <div className="data">+1 234 56 78 99</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="labelIcon ml-110"><Image src={icon_country}/>Country</div>
                            <div className="data ml-110">Mexico</div>
                        </div>
                        <div className="col-md-4">
                            <div className="labelIcon"><Image src={icon_doc}/>API Project</div>
                            <div className="data">Nombre API Project</div>
                        </div>
                        <div className="col-md-4">
                            <div className="labelIcon"><Image src={icon_puzzle}/>APIs</div>
                            <div className="data">+1 234 56 78 99</div>
                        </div>
                    </div>
                    {/* <div className="col-md-12">
                        <div className="messageContainer mt-3">
                            <p className="title">AVAP ID</p>
                            <hr className='w-100' />
                            <p className="message">La ficha de desarrollador, la puedes editar desde el perfil de AVAP ID raíz de este API Project.</p>
                        </div>
                    </div> */}


                </div>
            </div>

            <FooterMenuAccess green={true} />

        </>
    )
}

export default devInfo;